import { CheckCircle } from 'lucide-react'
import { AuthLayout } from '@/modules/auth/ui/components'

export type ReturningToAppStateProps = {
  organizationName: string
}

export function ReturningToAppState({ organizationName }: ReturningToAppStateProps) {
  return (
    <AuthLayout title="You're all set!" subtitle={`Welcome to ${organizationName}.`}>
      <div className="flex flex-col items-center gap-4 text-center">
        <CheckCircle className="size-12 text-primary" aria-hidden />
        <p className="text-sm text-muted-foreground">
          You can close this window and head back to the app to continue.
        </p>
      </div>
    </AuthLayout>
  )
}
